module.exports = __webpack_public_path__ + "img/michael-circle.6a35dee6.png";